import { GzContentControlWebWebComponent } from './component/GzContentControlWebWebComponent';

export { GzContentControlWebWebComponent };
